enum DataType {
    String = 1,
    Integer = 2,
    Decimal = 3,
    Boolean = 5,
    Date = 6,
    MultipleDates = 7,
    DateRange = 8,
    Address = 9,
    SortCode = 10,
    Files = 11,
    Rows = 12,
    SelectedOption = 13,
    MultipleOptions = 14,
    MonthYear = 15,
}

export { DataType };